import React from 'react';
import { Link } from 'react-router-dom';
import itchioLogo from '../assets/images/footer/itchio.png';
//import pixivLogo from '../assets/images/footer/pixiv.png';
import fanboxLogo from '../assets/images/footer/fanbox.png';
import baraagLogo from '../assets/images/footer/baraag.png';
import xLogo from '../assets/images/footer/x.png';
import BskyLogo from '../assets/images/footer/bluesky.png';
import loversLabLogo from '../assets/images/footer/loversLab.png';
import fade1 from '../assets/images/footer/fade-1.png';
import fade2 from '../assets/images/footer/fade-2.png';

const imgHeight = '40px';

const SiteFooter: React.FC = () => {

    return (
        <nav className="navbar navbar-expand-lg custom-navbar mt-5">

            {/* Background Images */}
            <img
                src={fade1}
                alt="Navbar fade left"
                className="navbar-bg fade-left"
            />
            <img
                src={fade2}
                alt="Navbar fade right"
                className="navbar-bg fade-right"
            />

            <div className="container-fluid justify-content-center">
                <Link className="navbar-brand" to="https://secretariamods.itch.io/" target="_blank">
                    <img
                        src={itchioLogo}
                        alt="itch.io Logo"
                        style={{ maxWidth: 'auto', height: imgHeight }}
                    />
                </Link>

                <Link className="navbar-brand" to="https://secretaria.fanbox.cc/" target="_blank">
                    <img
                        src={fanboxLogo}
                        alt="Fanbox Logo"
                        style={{ maxWidth: 'auto', height: imgHeight }}
                    />
                </Link>

                <Link className="navbar-brand" to="https://baraag.net/@secretariacreations" target="_blank">
                    <img
                        src={baraagLogo}
                        alt="Baraag Logo"
                        style={{ maxWidth: 'auto', height: imgHeight }}
                    />
                </Link>

                <Link className="navbar-brand" to="https://x.com/secretariamods" target="_blank">
                    <img
                        src={xLogo}
                        alt="X (Formerly Twitter) Logo"
                        style={{ maxWidth: 'auto', height: imgHeight }}
                    />
                </Link>

                <Link className="navbar-brand" to="https://bsky.app/profile/secretariamods.bsky.social" target="_blank">
                    <img
                        src={BskyLogo}
                        alt="Bluesky Logo"
                        style={{ maxWidth: 'auto', height: imgHeight }}
                    />
                </Link>

                <Link className="navbar-brand" to="https://www.loverslab.com/profile/11193459-secretaria/" target="_blank">
                    <img
                        src={loversLabLogo}
                        alt="LoversLab Logo"
                        style={{ maxWidth: 'auto', height: imgHeight }}
                    />
                </Link>
            </div>
        </nav>
    );
};

export default SiteFooter;
